import {Injectable} from '@angular/core';

import 'rxjs/add/operator/toPromise';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import {ApiService} from './api.service';
import 'rxjs/add/operator/delay';
import 'rxjs/add/operator/do';
import {ContractEvent} from '../model/Entities/ContractEvent';

@Injectable()
export class ContractEventService extends ApiService<ContractEvent> {

    protected apiUrl = 'api/events';  // URL to web api

    protected getObjectType(): any {
        return ContractEvent;
    }
}



// WEBPACK FOOTER //
// /app/src/services/event.service.ts